import { EyeClosed } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconEyeClosed12Line = createIcon(EyeClosed, 12, "Line");
export const IconEyeClosed16Line = createIcon(EyeClosed, 16, "Line");
export const IconEyeClosed20Line = createIcon(EyeClosed, 20, "Line");
export const IconEyeClosed24Line = createIcon(EyeClosed, 24, "Line");
export const IconEyeClosed32Line = createIcon(EyeClosed, 32, "Line");
export const IconEyeClosed48Line = createIcon(EyeClosed, 48, "Line");
export const IconEyeClosed64Line = createIcon(EyeClosed, 64, "Line");
